// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1nwkG","buttons":"RemoveExpirationActionButtons_buttons__1LC29"};